import { MoveCoord } from '../../jscaip/MoveCoord';
export class PenteMove extends MoveCoord {
    static encoder = MoveCoord.getEncoder(PenteMove.of);
    static of(coord) {
        return new PenteMove(coord.x, coord.y);
    }
    constructor(x, y) {
        super(x, y);
    }
    toString() {
        return `PenteMove(${this.coord.x}, ${this.coord.y})`;
    }
}
